/**
 * Decides whether Editor's external content sync should replace the document with `target`.
 * `setContent` moves the caret to the end, so every case that is not a real outside change must skip.
 */
export function shouldSyncExternalContent(args: {
  /** The `content` prop as received. */
  content: string
  /** The last value the editor itself emitted through `onChange`; null when nothing is pending. */
  lastEmitted: string | null
  /** `processedContent` — what the editor would display for `content`. */
  target: string
  currentHtml: string
  /** True when the editor or its DOM holds focus. */
  focused: boolean
}): boolean {
  const { content, lastEmitted, target, currentHtml, focused } = args
  if (currentHtml === target) return false
  // Our own edit echoing back. The template round trip is not byte-identical (zero-width spaces,
  // entities), so the HTML check above misses it. This matters when the edit came from a popover that
  // holds DOM focus (e.g. the placeholder picker): TipTap only refocuses on the next frame, so the
  // focus guard below lets it through and the caret jumps to the end (#25236).
  if (lastEmitted !== null && content === lastEmitted) return false
  if (focused) return false
  return true
}
